<template>
  <div v-for="(item,index) in payList" :key="index" style="font-size: 14px; margin: 8px 0">
    <div style="display: flex; flex-wrap: wrap;">
      <span style="margin-right: 8px;">{{item.createTime}}</span>
      <el-tag size="small">{{item.adminName}}</el-tag>
    </div>
    <p><span style="font-weight: bold">项目：</span>{{item.projectAllContent}}</p>
    <p><span style="font-weight: bold">支付：</span>{{item.paymentDetailContent}}</p>
  </div>
</template>

<script>
export default {
  name: "UserLog",
  props: {
    payList: {
      type: Array,
      default: [],
    }
  }
}
</script>

<style scoped>

</style>
